import React, { Component } from "react";
import { Spin } from "antd";
import PharmacyListView from "./PharmacyListView";
import { getPharmacyList } from "../../services/pharmacyService";
import { showErrorNotification, strings, history } from "../../helpers";

export default class PharmacyListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pharmacyList: [],
      isProcessing: false,
      totalRecords: 0,
      totalPage: 0,
      pageNo: 1,
      searchText: "",
      stateName: ""
    };
  }
  componentDidMount() {
    this.getPharmacyList();
  }

  /**
   * @function  navigateToPharmacyDetails
   * @param "e","pharamacyId"
   * @description This function redirect the user to clinic-details
   */
  navigateToPharmacyDetails = (e, pharamacyId) => {
    e.preventDefault();
    history.push(`/pharmacy-details/${pharamacyId}/basic-details`);
  };

  /**
   * @function getPharmacyList
   * @description This function get pharmacy data
   */
  getPharmacyList = () => {
    const { pageNo, searchText, stateName } = this.state;
    this.setState({
      isProcessing: true
    });

    getPharmacyList(pageNo, searchText, stateName)
      .then(response => {
        this.setState({
          isProcessing: false
        });
        if (response.data.success) {
          const { pharmacies } = response.data.data;
          const { total_records } = response.data.data;
          const { total_pages } = response.data.data;
          this.setState({
            pharmacyList: pharmacies,
            totalRecords: total_records,
            totalPages: total_pages
          });
        } else {
          this.setState({
            pharmacyList: [],
            isProcessing: false,
            totalRecords: 0,
            totalPages: 0
          });
        }
      })
      .catch(() => {
        showErrorNotification(strings.error_msg);
        this.setState({ pharmacyList: [], isProcessing: false });
      });
  };

  /**
   * @function onPageChange
   * @param page
   * @description This function get called on page change
   */
  onPageChange = page => {
    this.setState({ pageNo: page, pharmacyList: [] }, () => {
      this.getPharmacyList();
    });
  };

  /**
   * @function handleSearch
   * @description This function get called when clicked on pres button
   */
  handleSearch = () => {
    this.setState({ pageNo: 1, pharmacyList: [] }, () => {
      this.getPharmacyList();
    });
  };

  /**
   * @function handleStateChange
   * @description This function get called when clicked on search icon
   */
  handleStateChange = e => {
    this.setState({ stateName: e.target.value });
  };

  /**
   * @function handleSearchText
   * @description This function get called when clicked on search icon
   */
  handleSearchText = e => {
    this.setState({ searchText: e.target.value });
  };

  /**
   * @function  handleStateSearch
   * @description This function get called when clicked on press enter
   */
  handleStateSearch = () => {
    this.setState({ pageNo: 1, pharmacyList: [] }, () => {
      this.getPharmacyList();
    });
  };

  render() {
    const {
      pharmacyList,
      isProcessing,
      totalRecords,
      totalPages,
      pageNo,
      searchText,
      stateName
    } = this.state;
    return (
      <Spin spinning={isProcessing}>
        <PharmacyListView
          pharmacyList={pharmacyList}
          allRecords={totalRecords}
          allPages={totalPages}
          pageNo={pageNo}
          stateName={stateName}
          searchText={searchText}
          onPageChange={this.onPageChange}
          handleSearchText={this.handleSearchText}
          handleSearch={this.handleSearch}
          handleStateChange={this.handleStateChange}
          handleStateSearch={this.handleStateSearch}
          navigateToPharmacyDetails={this.navigateToPharmacyDetails}
        />
      </Spin>
    );
  }
}
